
export const iso_from_ts = (ts) => {
    if (ts === 0) return "--"
    let d = new Date(ts)
    let year = d.getFullYear();
    let day = d.getDate();
    let month = d.getMonth() + 1;
    if (month < 10) month = '0'+month;
    if (day < 10) day = '0'+day;
    return year+'-'+month+'-'+day;
}

export const capitalize = (s) => {
    if (s==null) return null;
    else {
        s = s.toLowerCase();
        return s.replace(/(?:^|\s)\S/g, function(a) { return a.toUpperCase(); });
    }
}

export const play_audio = (name) => {
    let audio = new Audio(name);
    audio.volume = 0.2;
    audio.play();
}


export const slugify = (str) => {
    str = str.replace(/^\s+|\s+$/g, '');

    // Make the string lowercase
    str = str.toLowerCase();

    // Remove accents, swap ñ for n, etc
    var from = "ÁÄÂÀÃÅČÇĆĎÉĚËÈÊẼĔȆÍÌÎÏŇÑÓÖÒÔÕØŘŔŠŤÚŮÜÙÛÝŸŽáäâàãåčçćďéěëèêẽĕȇíìîïňñóöòôõøðřŕšťúůüùûýÿžþÞĐđßÆa·/_,:;";
    var to   = "AAAAAACCCDEEEEEEEEIIIINNOOOOOORRSTUUUUUYYZaaaaaacccdeeeeeeeeiiiinnooooooorrstuuuuuyyzbBDdBAa------";
    for (var i=0, l=from.length ; i<l ; i++) {
        str = str.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i));
    }

    // Remove invalid chars
    str = str.replace(/[^a-z0-9 -]/g, '')
    // Collapse whitespace and replace by -
    .replace(/\s+/g, '-')
    // Collapse dashes
    .replace(/-+/g, '-');

    return str;
}
